// extracted by css-extract-rspack-plugin
export default {"fileRemoveButton":"fileRemoveButton-Zo1Yni","addFileButton":"addFileButton-oiydFJ","addFileMenuList":"addFileMenuList-hVRwFJ"};